// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--RTVDb","unColapsed":"styles-module--unColapsed--OH8dz","listOptionalItensContainer":"styles-module--listOptionalItensContainer--VEBAt"};